import { A48ReportPerms } from "../enums/reports/a48-report-perms.enum";
import { A48ReportTypes } from "../enums/reports/reports.enum";
import { CplItemSubType } from "./enum/cpl-item-sub-type.enum";

export class CplA48ParaReportRequest {
    UserID: string;
    StartDate: Date;
    EndDate: Date;
    Type: A48ReportTypes;
    Perms: A48ReportPerms;
    ItemSubType?: CplItemSubType;
    ShowDetails: boolean;
    ShowUserPicker: boolean;
    ShouldGetAll: boolean;
    Offset?: number;
    Limit?: number;
}